import React, { useEffect, useState } from 'react';
import { Get, Post } from '../../actions'; 
import { UploadFiles } from '../../components/Upload';
import { getTranslation } from '../../heplers/translationHelper';
import CardComponent from '../../components/Card';
import { CardContent, Typography } from '@material-ui/core';
import LogoFile1 from "../../assests/icons/qollex-clicrent-logo.png";



export const SystemSetting = () => {
  const [logo, setLogo] = useState(null);
  const defaultLogo = LogoFile1;

  useEffect(() => {
    // Fetch the logo when the component mounts
    Get(
      null,
      'SystemSetting/GetLogo',
      null,
      (response) => {
        if (response.data.logo) {
          setLogo(response.data.logo);
        
        } else {
          setLogo(defaultLogo);
    
        }
      },
      (error) => {
        console.error('Error fetching logo:', error);
        setLogo(defaultLogo);

      }
    );
  }, []);

  const handleFileUpload = (file) => {
    const formData = new FormData();
    formData.append('logo', file);
    formData.append('id', 0);

    Post(
      { logo: file },
      'SystemSetting/UpdateLogo',
      null,
      (response) => {
        setLogo(file); 
      },
      (error) => {
        console.error('Error uploading logo:', error);
      }
    );
  };

  return (
    <CardComponent title="Upload Logo">
      <CardContent>
        <UploadFiles
          uploadedFiles={logo ? [logo] : []}
          getFileName={(file) => file}
          multiple={false}
          onAddFile={handleFileUpload}
          accept="image/jpeg, image/png, image/gif"
        />

        <Typography variant="h5" style={{ marginLeft: '20px' }}>
          {getTranslation('Set Logo', 'Set Logo', 'Set Logo')}
        </Typography>
      </CardContent>
    </CardComponent>
  );
};

export default SystemSetting;
